import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { companyMappingResponseToVM, CompanyMappingVM } from '../../../schemas/CompanyMappings.schema';
import { getCompanyMappings } from '../../../services/queries/MaggieCompanyQueries';
import { mappingsGridApiAtom } from './CompanyMappingsState';

export function useInvalidateMappingsAndUpdateGrid() {
  const gridApi = useAtomValue(mappingsGridApiAtom);
  return useCallback(
    async (updatedRowIds: Set<string>) => {
      const allMappingsLatest = await getCompanyMappings();
      const latestMappingsById = new Map(allMappingsLatest.map((item) => [item.id, item]));

      const toUpdate: CompanyMappingVM[] = [];
      const toDelete: { id: string }[] = [];
      updatedRowIds.forEach((id) => {
        const mapping = latestMappingsById.get(id);
        if (mapping) {
          // The "Will create" chip is derived from the company id, so a refetched row reflects
          // reality: a successful create now carries a real id (no chip); an unresolved one doesn't.
          toUpdate.push({ ...companyMappingResponseToVM(mapping), modified: false });
        } else {
          toDelete.push({ id });
        }
      });

      gridApi?.applyTransaction({ update: toUpdate, remove: toDelete });
      gridApi?.deselectAll();
    },
    [gridApi]
  );
}
